import { injectable } from "inversify";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/ErrorEntity";
import ShiftEntity from "../../entities/ShiftEntity";
import ShiftRepository from "../../repositories/ShiftRepository";

interface _Props {
    shiftRepository: ShiftRepository;
}

@injectable()
export default class ReasignShiftUseCase {
    private shiftRepository: ShiftRepository;
    
    constructor(props: _Props) {
        this.shiftRepository = props.shiftRepository;
    }
    
    public call = async (_:{
        shiftId: string, newUserId: string, oldUserId: string, reason: string
    }): Promise<Either<ErrorEntity, ShiftEntity>> => {
        return await this.shiftRepository.reasignShift(_);
    }
}

export const ReasignShiftUseCaseName = "ReasignShiftUseCase";